import { Reveal, SectionEyebrow } from "./Reveal";
import { CROSS_STEPS } from "../../data";
import { AlertTriangle } from "lucide-react";

export const CrossBorder = () => (
  <section id="cross-border" className="relative bg-oyf-charcoal text-white py-20 md:py-28 overflow-hidden" data-testid="cross-border">
    <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
      <svg width="100%" height="100%"><defs><pattern id="grid" width="48" height="48" patternUnits="userSpaceOnUse"><path d="M48 0H0V48" fill="none" stroke="#fff" strokeWidth="1" /></pattern></defs><rect width="100%" height="100%" fill="url(#grid)" /></svg>
    </div>
    <div className="container-oyf relative z-10">
      <div className="max-w-3xl">
        <SectionEyebrow dark>Cross-Border Coordination</SectionEyebrow>
        <h2 className="font-display font-extrabold tracking-tight text-3xl md:text-5xl leading-[1.02]">
          Clear Communication From Pickup to Border to Delivery
        </h2>
        <p className="mt-5 text-white/65 text-base md:text-lg leading-relaxed">
          Cross-border freight depends on accurate information, prepared documentation and communication among the customer, carrier, driver and authorized customs broker.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CROSS_STEPS.map((s, i) => (
          <Reveal key={s.t} delay={(i % 3) * 0.08}>
            <div className="relative h-full bg-white/[0.04] border border-white/10 rounded-lg p-6 hover:border-oyf-yellow/60 transition-colors duration-300">
              <span className="font-display font-extrabold text-oyf-yellow text-3xl">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display font-bold text-white text-lg mt-3">{s.t}</h3>
              <p className="text-sm text-white/60 mt-2 leading-relaxed">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <div className="mt-10 flex gap-4 bg-oyf-yellow/10 border border-oyf-yellow/40 rounded-lg p-5" data-testid="customs-alert">
          <AlertTriangle size={22} className="text-oyf-yellow shrink-0 mt-0.5" />
          <p className="text-sm text-white/80 leading-relaxed">
            Customs clearance is completed by the applicable government authorities and the shipment&apos;s authorized customs broker. Processing times can be affected by documentation, inspections, traffic, weather and agency requirements.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
